import { render, staticRenderFns } from "./add-banner.vue?vue&type=template&id=d1b438f4&scoped=true"
import script from "./add-banner.vue?vue&type=script&lang=js"
export * from "./add-banner.vue?vue&type=script&lang=js"
import style0 from "./add-banner.vue?vue&type=style&index=0&id=d1b438f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b438f4",
  null
  
)

export default component.exports